var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"title":_vm.$t('미리보기'),"mStyle":_vm.modalSize},on:{"close":_vm.handleCloseModal}},[_c('div',{staticClass:"design-preview-modal-content-inner"},[_c('PartsLayout',{attrs:{"layout":_vm.layout,"parts":_vm.parts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }